import React from 'react'
import { format } from 'date-fns'

import Img from 'components/base/Img'
import HeaderMeta from 'components/HeaderMeta'
import Link from 'components/base/Link'
import Loading from 'components/base/Loading'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import { ContentWrapper } from 'components/blocks/Blog/ContentWrapper/styles'
import CtaQuote from 'components/blocks/CtaQuote'
import BlogPostsGrid from 'components/blocks/Blog/PostsGrid'
import PostTagsList from 'components/blocks/Blog/PostTagsList'

import { Props } from './types'

import {
  Post,
  PostImage,
  PostDate,
  PostTitle,
  PostNavigation,
  RelatedPosts,
} from './styles'

const BlogPost: React.FC<Props> = ({
  isLoading,
  onRelatedPostsLoaded,
  post,
  showRelatedPosts,
  tagSlugs,
}): React.ReactElement => (
  <>
    <HeaderMeta
      title={`${post?.title ? `${post.title} | ` : ''}Insurance Lounge Blog`}
      description={post?.meta_description || 'Insurance Lounge Blog'}
      keywords={post?.meta_keywords || ''}
      ogImg='/images/og-images/About.webp'
    />
    {(isLoading && (
      <Post>
        <Loading />
      </Post>
    )) || (post && (
      <>
        <Post>
          <PostTitle>
            <h1>{post.title}</h1>
          </PostTitle>
          <PostDate>Date: {format(post.created_at, 'MM.DD.YYYY')}</PostDate>
          {post.featured_image && (
            <PostImage>
              <Img
                src={post.featured_image.url}
                src2x={undefined}
                alt={post.featured_image.alt}
              />
            </PostImage>
          )}
          <ContentWrapper dangerouslySetInnerHTML={{ __html: post.content }} />
          <PostTagsList tags={post.tags} />
        </Post>

        {((post.previous_post || post.next_post) && (
          <PostNavigation>
            <div>
              <div>
                {post.previous_post && <Link to={`/blog/posts/${post.previous_post.slug}`}>&lt; Previous Post</Link>}
              </div>
              <div>
                {post.next_post && <Link to={`/blog/posts/${post.next_post.slug}`}>Next Post &gt;</Link>}
              </div>
            </div>
          </PostNavigation>
        ))}
        {(tagSlugs && (
          <RelatedPosts show={showRelatedPosts}>
            <h2>Related Posts</h2>
            <BlogPostsGrid tagSlugs={tagSlugs} exceptPostSlug={post.slug} onPostsLoaded={onRelatedPostsLoaded} />
          </RelatedPosts>
        ))}
        <CtaQuote
          trackingInfo={{
            button_position: 'bottom',
            page_category: 'blog',
          }}
        />
      </>
    )) || <Paragraph theme={ParagraphTheme.centered}>An error has occurred.</Paragraph>}
  </>
)

export default BlogPost
